import { useCallback } from 'react';
import { createConversationUserMessage } from '@wix/ambassador-genie-chat-service-v1-no-entity/http';
import { mapMessage } from '../convertMessages';
export const useCreateUserMessage = httpClient => {
  return useCallback(async payload => {
    if (!httpClient) {
      throw new Error('httpClient is not defined');
    }
    try {
      var _response$data;
      const request = createConversationUserMessage(payload);
      const response = await httpClient.request(request);
      const conversationUserMessage = (_response$data = response.data) == null ? void 0 : _response$data.userMessage;

      // preserve client side attachments and references
      const userMessage = {
        ...conversationUserMessage,
        attachments: payload.attachments,
        references: payload.messageReferences
      };
      return mapMessage(userMessage);
    } catch (error) {
      throw error;
    }
  }, [httpClient]);
};
//# sourceMappingURL=useCreateUserMessage.js.map